import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { getUserLists } from '~~/src/api/lists'
import type { GetReturn } from '~~/src/types/utils'

type FnArgs = Parameters<typeof getUserLists>

export const useUserListsQuery = (
  args: {
    userId?: MaybeRef<FnArgs[0] | undefined>
    query?: MaybeRef<FnArgs[1]>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getUserLists>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getUserLists>, Error> => {
  const queryRaw = unref(args.query)
  return useQuery({
    queryKey: ['user-lists', args.userId, queryRaw?.elemental_type_id, args.query] as const,
    queryFn: async ({ queryKey, signal }) => {
      const [_, userId, __, query] = queryKey
      if (!userId)
        return null

      return getUserLists(userId, query, signal)
    },
    ...options,
  })
}
